import { useThirdPartyFeedbackIntegration } from 'api/integrationsConfig'
import {
  feedbackProviderName,
  owningThirdPartyProvider,
} from '../../feedbackOwnership'
import { useWrittenFeedbackPersisted } from './useWrittenFeedbackEnabled'

// The name of the third-party tool that owns this merchant's feedback, or null
// when none does. A tool owns it only while the SAVED written-feedback toggle is
// off, so this never decides whether a pane is gated, only which note explains
// the gate.
export const useOwningFeedbackToolName = (): string | null => {
  const { thirdPartyFeedbackProvider } = useThirdPartyFeedbackIntegration()
  const writtenFeedbackEnabled = useWrittenFeedbackPersisted()

  const owner = owningThirdPartyProvider(
    writtenFeedbackEnabled,
    thirdPartyFeedbackProvider
  )
  return feedbackProviderName(owner) ?? null
}
